$(function() {
    var now = new Date();
    var yy = now.getFullYear();
    var mm = now.getMonth() + 1;
    var dd = now.getDate();

    function accordion (){
      $('.toggle').click(function(){
        //$('.accordion-overlay,.accordion-btn-overlay').addClass('is-active');
        var cnt = $('.option input:checkbox:checked').length;
        $('.agree_checkbox a').css('pointer-events', 'none');
        
        if (cnt < 1){
          //$('.accordion-overlay,.accordion-btn-overlay').removeClass('is-active');
          $('.agree_checkbox a').css('pointer-events', 'auto');
          
        }
      });
    }

    accordion();

//    fetch(`https://create.rettel-tokyo.com/api/v1/organizer/delivery/day/?date=${yy}/${mm}/${dd}`, {
    fetch(`https://rettel.f-stg.jp/api/v1/organizer/delivery/day/?date=${yy}/${mm}/${dd}`, {
      method: 'GET',
      headers: { 'Authorization': 'Basic ' + btoa('rettele:eM5E2cNg') }
    }).then((response) => response.json()).then((data) => {
      var d = data;
      if(d.notice.length > 0) {
        $('.product-outOfStock').addClass('is-show');
        $('.product-form__submit').addClass('is-disabled');
        $('.agree_checkbox input[type=checkbox]').prop('disabled', true);
        $('.product-form__submit').removeClass('js-disabled');

        accordion();

      } else {
        $('.product-outOfStock').removeClass('is-show');
        $('.product-form__submit').removeClass('is-disabled');
        $('.agree_checkbox input[type=checkbox]').prop('disabled', false);

        accordion();

      }
    }).catch((e) => {
      reject(e);
    });
});